import React, { useEffect } from "react";
import { X, ClipboardList } from "lucide-react";
import { useForm, Controller } from "react-hook-form";

const AddReplacementModal = ({ isOpen, onClose, onSave, itemData, languageOptions }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      target: "",
      replacement: "",
      language: "Hinglish",
    },
  });

  useEffect(() => {
    if (itemData) {
      reset({
        target: itemData.target || "",
        replacement: itemData.replacement || "",
        language: itemData.language || "Hinglish",
      });
    } else {
      reset({
        target: "",
        replacement: "",
        language: "Hinglish",
      });
    }
  }, [itemData, isOpen, reset]);

  const onSubmit = (data) => {
    const payload = {
      target: data.target,
      replacement: data.replacement,
      language: data.language,
    };

    onSave(payload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-subparam-overlay">
      <div className="add-subparam-modal">
        {/* Header */}
        <div className="add-subparam-header">
          <h3>
            <ClipboardList size={18} style={{ marginRight: "6px" }} />
            {itemData ? "Edit Replacement Word" : "Add Replacement Word"}
          </h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <form
          id="replacementForm"
          onSubmit={handleSubmit(onSubmit)}
          className="add-subparam-body"
        >
          <label>Target Word / Phrasing (Text to replace)</label>
          <Controller
            name="target"
            control={control}
            rules={{ 
              required: "Target word is required",
              validate: value => value.trim() !== "" || "Target word cannot be only spaces"
            }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${errors.target ? "error" : ""}`}
                placeholder="e.g.  main  (Note: Include leading/trailing spaces if needed)"
              />
            )}
          />
          {errors.target && (
            <p className="error-text">{errors.target.message}</p>
          )}

          <label>Replacement Word (Substituted text)</label>
          <Controller
            name="replacement"
            control={control}
            rules={{ 
              required: "Replacement word is required",
              validate: value => value.trim() !== "" || "Replacement word cannot be only spaces"
            }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${errors.replacement ? "error" : ""}`}
                placeholder="e.g.  मैं "
              />
            )}
          />
          {errors.replacement && (
            <p className="error-text">{errors.replacement.message}</p>
          )}

          <label>Language</label>
          <Controller
            name="language"
            control={control}
            rules={{ required: "Language selection is required" }}
            render={({ field }) => (
              <select
                {...field}
                className={`form-control ${errors.language ? "error" : ""}`}
              >
                {languageOptions && languageOptions.length > 0 ? (
                  languageOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))
                ) : (<></>
                )}
              </select>
            )}
          />
          {errors.language && (
            <p className="error-text">{errors.language.message}</p>
          )}
        </form>

        {/* Footer */}
        <div className="add-subparam-footer">
          <button
            type="button"
            className="popup-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="replacementForm"
            className="popup-add-btn"
          >
            {itemData ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddReplacementModal;
